<template>
  <div>
    <div v-if="goods">
      <v-row align="center">
        <v-col cols="12" class="text-center">
          <v-icon slot="icon" color="error" size="30">
            mdi-cloud-off-outline
          </v-icon>
          <h3>
            К сожалению данного товара нет в прайсе, вы можете использовать ниже
            варианты
          </h3>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" class="text-center">
          <v-divider class="mx-4" />
          <v-card-title>
            {{ stringValues.searcByAnalogs[currentLanguage.language] }}
          </v-card-title>

          <v-card-text>
            <v-chip-group v-model="selection" column>
              <v-chip @click="SetSearch('inn')" color="primary" outlined>
                МНН:
                <span class="font-weight-bold">{{ goods.inn.name }}</span>
              </v-chip>
              <v-chip @click="SetSearch('brand')" color="primary" outlined>
                {{ stringValues.brend[currentLanguage.language] }}:
                <span class="font-weight-bold">{{ goods.brand.name }}</span>
              </v-chip>
              <v-chip @click="SetSearch('atc')" color="primary" outlined>
                АТХ:
                <span class="font-weight-bold">{{ goods.atc.name }}</span>
              </v-chip>
              <v-chip @click="SetSearch('producer')" color="primary" outlined>
                Производитель:
                <span class="font-weight-bold">{{ goods.producer.name }}</span>
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-col>

        <v-col cols="12" class="text-center" v-if="!notification">
          <v-divider class="mx-4" />

          <v-card-title class="headline">
            Уведомить меня в случае появления товара в прайсе
          </v-card-title>

          <v-card-subtitle>
            (В данный момент доступно уведомление по Фарм-чат)
          </v-card-subtitle>

          <v-card-text>
            <v-btn
              @click="CreateNotification()"
              :disabled="notificationButton"
              color="primary"
            >
              Уведомить
            </v-btn>
          </v-card-text>
        </v-col>

        <v-col cols="12" class="text-center" v-else>
          <v-divider class="mx-4" />
          <v-card-subtitle>
            Вы подписаны на уведомление. Когда товар появится в прайсе, вы
            будете в курсе.
          </v-card-subtitle>
        </v-col>

        <!-- PC_NEW-656: один баннер — «Альтернатива» (зона 4) по SKU, иначе «Новинки» (зона 3);
             рамку не рисуем, если показывать нечего -->
        <v-col v-if="hasAlternativeAd || hasNewGoodsAd">
          <v-card class="my-3" outlined>
            <AdTemplate
              v-if="adGoods && adGoods.includes(goods.id)"
              :adLocation="4"
              :goodsId="goods.id"
            />
            <AdTemplate
              v-else-if="hasNewGoodsAd"
              :adLocation="3"
              :box-height="250"
              hide-empty
              fit-width
              width="100%"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-col cols="12" class="text-center">
        <v-card-subtitle class="headline">
          {{ stringValues.chooseGoodToSeePrice[currentLanguage.language] }}.
        </v-card-subtitle>
      </v-col>
    </div>
  </div>
</template>

<script>
import { hasVisibleSlides } from "../../utils/adZones";

export default {
  data: () => ({
    selection: -1,
    notification: null,
    notificationButton: false,
  }),
  computed: {
    stringValues() {
      return this.$store.getters.STRING_VALUES;
    },
    currentLanguage() {
      return this.$store.getters.CURRENT_LANG;
    },
    goods() {
      return this.$store.getters.PRICE_BY_GOODS_ID.goods;
    },
    adGoods() {
      const ads = this.$store.getters.ADS?.find((x) => x.id == 4)?.adItems?.map(
        (x) => Number(x.goodsId)
      ) || [];

      return ads;
    },
    // PC_NEW-656: у выбранного SKU есть слайды «Альтернативы» — показываем только их
    hasAlternativeAd() {
      return hasVisibleSlides(this.$store.getters.ADS, 4, {
        goodsId: this.goods?.id,
      });
    },
    // PC_NEW-656: в «Новинках» есть хоть один слайд с картинкой
    hasNewGoodsAd() {
      return hasVisibleSlides(this.$store.getters.ADS, 3, { hideEmpty: true });
    },
  },
  methods: {
    CreateNotification() {
      this.notificationButton = true;
      this.$store
        .dispatch("CREATE_NOTIFICATION", { goodsId: this.goods?.id })
        .then(() => {
          this.notification = {};
          this.notificationButton = false;
        })
        .catch((error) => {
          window.console.log(error);
          this.notificationButton = false;
        });
    },
    GetNotificationByGoodsId() {
      this.$store
        .dispatch("NOTIFICATION_BY_GOODS_ID", this.goods?.id)
        .then((response) => {
          this.notification = response;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    SetSearch(type) {
      const Search = {
        fullName: "",
        beInThePrices: false,
        advanced: {
          INN: type === "inn" ? this.goods?.inn?.name : "",
          brand: type === "brand" ? this.goods?.brand?.name : "",
          ATC: type === "atc" ? this.goods?.atc?.name : "",
          producer: type === "producer" ? this.goods?.producer?.name : "",
          show: true,
        },
      };
      this.$store.commit("SET_GOODS_SEARCH", Search);
    },
  },
  created() {
    this.GetNotificationByGoodsId();
  },
};
</script>